import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DEFAULT_PAGINATION, PER_PAGE_OPTIONS } from '../../../constants';
import SimpleSelectGroup from '../Forms/SimpleSelectGroup';

const PerPageOption = ({ label, disabled, value, options, onChange }) => {
     const handleChange = useCallback(
          (e) => {
               const perPage = e.target.value;
               onChange(Number(perPage));
          },
          [onChange]
     );

     return (
          <div className="row per-page">
               <label className="form-label col-auto col-form-label">{label}</label>
               <div className="col-auto per-page-select">
                    <SimpleSelectGroup
                         id="per-page"
                         className={classNames('mb-0', {
                              [disabled]: disabled,
                         })}
                         optionDefault={false}
                         data={options}
                         value={`${value}`}
                         handleChange={handleChange}
                    />
               </div>
          </div>
     );
};

PerPageOption.propTypes = {
     label: PropTypes.string,
     disabled: PropTypes.bool,
     options: PropTypes.array,
     onChange: PropTypes.func,
};

PerPageOption.defaultProps = {
     label: 'Items per page:',
     value: DEFAULT_PAGINATION.PAGE_SIZE,
     options: PER_PAGE_OPTIONS,
};

export default memo(PerPageOption);
